import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from './TableHead'
import PureSponsor from './PureSponsor'
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

class TableSponsor extends React.Component {
  constructor(props){
      super(props);
      this.state = {
      }
    }

    renderSponsor = () => {
      return (
        this.props.sponsor.map((sponsor, index) => (
        <PureSponsor intl={this.props.intl} refParent={this.props.refParent} deleting={this.props.deleting} sponsor={sponsor} key={sponsor.Id} index={index}/>
      ))
      )
    }

 render() {
   return (
     <Table>
      <TableHead refParent={this.props.refParent}/>
      {
        this.props.sponsor.length === 0 && this.state.loadingMore === false  ?
        <TableBody>
          <TableRow>
            <TableCell  colSpan={"6"}>
              <Container fluid>
                <Row>
                  <Col xl={12} lg={12} md={12} sm={12} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 3}}>
                    <p style={{color: 'black', fontSize: '1.2rem', fontWeight: 'bold'}}>Pas de résultats</p>
                  </Col>
                </Row>
              </Container>
            </TableCell>
          </TableRow>
        </TableBody>
        :
        <TableBody>
          {this.renderSponsor()}
        </TableBody>
      }

    </Table>
   )
 }
}


export default TableSponsor;
